var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65234 5.43258C4.65234 4.0233 5.8099 2.88086 7.23782 2.88086H10.9985C11.3879 2.88086 11.7036 3.19243 11.7036 3.57678C11.7036 3.96113 11.3879 4.27271 10.9985 4.27271H7.23782C6.58877 4.27271 6.06261 4.792 6.06261 5.43258V6.36048C6.06261 6.74483 5.74691 7.0564 5.35747 7.0564C4.96804 7.0564 4.65234 6.74483 4.65234 6.36048V5.43258ZM5.35747 14.9436C5.74691 14.9436 6.06261 15.2551 6.06261 15.6395V16.5674C6.06261 17.2079 6.58877 17.7272 7.23782 17.7272H10.9985C11.3879 17.7272 11.7036 18.0389 11.7036 18.4231C11.7036 18.8075 11.3879 19.1191 10.9985 19.1191H7.23782C5.8099 19.1191 4.65234 17.9766 4.65234 16.5674V15.6395C4.65234 15.2551 4.96804 14.9436 5.35747 14.9436Z",
    fill: "#F7A703"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7032 4.38725C11.7032 3.57942 12.519 3.01901 13.2866 3.29957L17.9875 5.0179C18.4485 5.18642 18.7544 5.62036 18.7544 6.10557V15.8943C18.7544 16.3795 18.4485 16.8134 17.9875 16.9819L13.2866 18.7003C12.519 18.9809 11.7032 18.4204 11.7032 17.6126V4.38725ZM13.7764 1.99437C12.0877 1.37712 10.293 2.61002 10.293 4.38725V17.6126C10.293 19.3898 12.0877 20.6227 13.7764 20.0054L18.4772 18.2871C19.4915 17.9164 20.1647 16.9617 20.1647 15.8943V6.10557C20.1647 5.0381 19.4915 4.08344 18.4772 3.71269L13.7764 1.99437Z",
    fill: "#F7A703"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79925 8.65208C6.07461 8.3803 6.52107 8.3803 6.79644 8.65208L8.67679 10.5079C8.95216 10.7797 8.95216 11.2202 8.67679 11.492L6.79644 13.3478C6.52107 13.6196 6.07461 13.6196 5.79925 13.3478C5.52387 13.0761 5.52387 12.6355 5.79925 12.3637L6.47586 11.6959H2.53716C2.14773 11.6959 1.83203 11.3843 1.83203 11C1.83203 10.6156 2.14773 10.304 2.53716 10.304H6.47586L5.79925 9.63624C5.52387 9.36445 5.52387 8.92385 5.79925 8.65208Z",
    fill: "#F7A703"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut1);
export default __webpack_public_path__ + "static/media/LogOut1.7600091f9043f4c2abebe96a3bfbe71a.svg";
export { ForwardRef as ReactComponent };